import { motion } from "framer-motion";
import { FolderUp, Wand2, BadgeCheck, ClipboardCheck, Send } from "lucide-react";

const STEPS = [
  { icon: FolderUp, title: "Share Your Assets", desc: "Send raw property footage, photos, details and advertising permit info via Drive or WhatsApp." },
  { icon: Wand2, title: "We Create", desc: "Our studio edits and designs your posts, reels, brochures and listing videos." },
  { icon: BadgeCheck, title: "Add Permit Details", desc: "We insert Trakheesi permit numbers and QR codes wherever required." },
  { icon: ClipboardCheck, title: "Quality Check", desc: "A pre-delivery checklist verifies all details against creative specifications." },
  { icon: Send, title: "Client Approval", desc: "You or your licensed agent reviews and authorises publication. Done." },
];

export const Process = () => {
  return (
    <section id="process" data-testid="process-section" className="py-16 sm:py-24 lg:py-28 bg-[#12203c] relative overflow-hidden">
      <div className="absolute inset-0 stars-bg opacity-30 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl"
        >
          <p className="font-code text-xs sm:text-sm uppercase tracking-[0.25em] text-[#fba31b] font-bold">Our Process</p>
          <h2 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            From Your Footage to <span className="text-[#fba31b]">Market-Ready Creative</span>
          </h2>
          <p className="mt-4 text-slate-300 text-base sm:text-lg">
            A simple, transparent process to get you high-quality creative, on time, every time.
          </p>
        </motion.div>

        <div className="mt-14 relative">
          <div className="hidden lg:block absolute top-7 left-[10%] right-[10%] border-t border-dashed border-[#fba31b]/25" />
          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-6">
            {STEPS.map((s, i) => (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, delay: i * 0.1 }}
                data-testid={`process-step-${i + 1}`}
                className="relative"
              >
                <div className="relative z-10 w-14 h-14 rounded-2xl bg-[#162544] border border-[#fba31b]/40 flex items-center justify-center">
                  <s.icon className="w-6 h-6 text-[#fba31b]" />
                </div>
                <div className="mt-4 font-code text-xs text-[#fba31b]/70 font-bold tracking-widest">STEP 0{i + 1}</div>
                <h3 className="mt-2 font-display text-lg font-bold">{s.title}</h3>
                <p className="mt-2 text-sm text-slate-400 leading-relaxed">{s.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
